module.exports = __webpack_public_path__ + "static/media/Pointing_UG_Left.50980c4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Pointing_UG_Left.png
// module id = 6141
// module chunks = 0